import { render, staticRenderFns } from "./WithdrawCryptoExchangeForm.vue?vue&type=template&id=a4157e34&scoped=true"
import script from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
export * from "./WithdrawCryptoExchangeForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawCryptoExchangeForm.vue?vue&type=style&index=0&id=a4157e34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4157e34",
  null
  
)

export default component.exports